import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCalendar,
  faClock,
  faMapMarkerAlt,
  faMoneyBillAlt,
  faHeadphones,
} from "@fortawesome/free-solid-svg-icons";

const Welcome = ({
  concert: {
    img,
    date,
    time,
    title,
    place,
    season,
    label,
    buy_link,
    buy_btn,
    lstn_link,
    lstn_btn,
  },
  formatDate,
  t,
  isExpired,
}) => {
  const isMMI = season === "mmi";
  const bgImage = img ? `url("${img}")` : "url('/img/homeBkg.jpg')";

  return (
    <section
      className="concert-hero"
      style={{
        backgroundImage: `linear-gradient(180deg, rgba(9, 12, 30, 0.72) 0%, rgba(9, 12, 30, 0.85) 60%, rgba(9, 12, 30, 0.98) 100%), ${bgImage}`,
      }}
    >
      <div className="container text-left">
        <div className="concert-hero-inner">
          {label && (
            <div className="concert-hero-badge-wrap">
              <span className={`concert-hero-badge ${isMMI ? "mmi" : ""}`}>
                {isMMI && (
                  <span className="kicker">
                    {t("concerts.season_tag")} •{" "}
                  </span>
                )}
                {t(`concerts.${label}`)}
              </span>
            </div>
          )}

          <h1 className="concert-hero-title text-capitalize">{title}</h1>

          <div className="concert-hero-meta">
            <div className="meta-item">
              <FontAwesomeIcon icon={faCalendar} className="meta-icon" />
              <span>{formatDate(date)}</span>
            </div>
            {time && (
              <div className="meta-item">
                <FontAwesomeIcon icon={faClock} className="meta-icon" />
                <span>
                  {t("concerts.at")} {time}
                </span>
              </div>
            )}
            {place && (
              <div className="meta-item place-item">
                <FontAwesomeIcon icon={faMapMarkerAlt} className="meta-icon" />
                <span>{place}</span>
              </div>
            )}
          </div>

          <div className="concert-hero-actions">
            {!isExpired && buy_link && (
              <a
                href={buy_link}
                target="_blank"
                rel="noopener noreferrer"
                className="concert-cta-btn buy"
              >
                <FontAwesomeIcon icon={faMoneyBillAlt} />{" "}
                {t(`concerts.${buy_btn || "buy_btn"}`)}
              </a>
            )}
            {lstn_link && (
              <a
                href={lstn_link}
                target="_blank"
                rel="noopener noreferrer"
                className="concert-cta-btn listen"
              >
                <FontAwesomeIcon icon={faHeadphones} />{" "}
                {t(`concerts.${lstn_btn || "lstn_btn"}`)}
              </a>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Welcome;
